import { halloweenTheme } from "./theme.config.js";
const assetBase = "/assets/quizzes/halloween";
const scenes = [
    {
        title: "Дорога на Хеловін",
        prompt: "Johnny and Archie ___ to the next town when the sky turned black.",
        story: "Джоні та Арчі їхали на вечірку, коли небо раптом стало чорним.\nАрчі виглядав так, ніби вже знав: буде дурня.",
        correct: "were driving",
        options: ["were driving", "drove", "drive", "have driven"]
    },
    {
        title: "Вони запізнювались",
        prompt: "They ___ late for the Halloween party.",
        story: "Вечірка мала початися опівночі, а вони вже запізнювалися.\nДжоні вирішив скоротити дорогу через Блеквуд - Арчі ця ідея одразу не сподобалася.",
        correct: "were",
        options: ["was", "were", "are", "be"]
    },
    {
        title: "Машина здалася першою",
        prompt: "The car suddenly ___ in the middle of the forest.",
        story: "Посеред лісу двигун кілька разів сіпнувся й остаточно замовк.\nДжоні зупинив машину та відкрив капот.",
        correct: "stopped",
        options: ["stop", "stopping", "was stop", "stopped"]
    },
    {
        title: "Телефон теж зрадив",
        prompt: "Johnny tried to call for help, but his phone ___ any signal.",
        story: "Джоні дістав телефон, щоб викликати допомогу.\nОстання поділка зв'язку зникла саме тоді, коли він натиснув кнопку виклику.",
        correct: "didn't have",
        options: ["doesn't had", "didn't have", "not had", "wasn't have"]
    },
    {
        title: "Арчі щось почув",
        prompt: "Archie looked into the darkness because he ___ something strange.",
        story: "Поки Джоні розглядав двигун, Арчі раптом насторожився.\nДесь між деревами тріснула гілка, хоча вітру не було.",
        correct: "heard",
        options: ["hear", "hearing", "heard", "was hear"]
    },
    {
        title: "Табличка, яку краще було прочитати раніше",
        prompt: "The sign said they ___ enter the forest after midnight.",
        story: "У світлі фар вони помітили стару табличку з попередженням не заходити до лісу після опівночі.\nНа телефоні Джоні було 00:03.",
        correct: "mustn't",
        options: ["mustn't", "don't must", "mustn't to", "not must"]
    },
    {
        title: "Будинок у тумані",
        prompt: "They saw an old house ___ the trees.",
        story: "Залишатися біля машини ставало дедалі менш затишно, тому вони пішли стежкою.\nКрізь туман і дерева показався старий покинутий будинок.",
        correct: "among",
        options: ["on", "at", "to", "among"]
    },
    {
        title: "Записка мисливця на нежить",
        prompt: "There was a note ___ the table.",
        story: "Усередині було порожньо, але на столі лежала записка: \"Я мисливець на нежить. Якщо мене досі немає - знайди зброю на кухні й тікай звідси!\"",
        correct: "on",
        options: ["in", "on", "at", "to"]
    },
    {
        title: "Хеловін плюс повний місяць",
        prompt: "Johnny realized it ___ not just Halloween, but also a full moon.",
        story: "Джоні визирнув у розбите вікно й побачив величезний повний місяць.\n\"Хеловін і повний місяць. Просто фантастичне співпадіння\", - пробурмотів він.",
        correct: "was",
        options: ["were", "is", "was", "be"]
    },
    {
        title: "Пошуки кухні",
        prompt: "Johnny was looking for the kitchen while Archie ___ behind him.",
        story: "Джоні ввімкнув ліхтарик і почав обходити темні кімнати в пошуках кухні.\nАрчі тримався позаду й прислухався до кожного шурхоту.",
        correct: "was walking",
        options: ["was walking", "walked", "walks", "walking"]
    },
    {
        title: "Часник, великий план Джоні",
        prompt: "Johnny thought garlic ___ vampires away.",
        story: "На кухні Джоні побачив зв'язку часнику й одразу згадав легенди про вампірів.\nВін переможно всміхнувся: зброю знайдено.",
        correct: "kept",
        options: ["keep", "keeps", "was keep", "kept"]
    },
    {
        title: "Арчі не вражений",
        prompt: "Johnny thought Archie ___ hungry.",
        story: "Побачивши Джоні з часником, Арчі почав нервово нявкати.\nДжоні вирішив, що кіт просто зголоднів: \"Заспокойся, зараз не до їжі\".",
        correct: "was",
        options: ["were", "was", "is", "be"]
    },
    {
        title: "Кіт натякає на очевидне",
        prompt: "If Johnny looked at the wall, he ___ the real weapon.",
        story: "\"Часник - це просто їжа, дурне ти людське створіння. На стіну подивись!\" - нервово пояснив Арчі котячою.\nДжоні нарешті простежив за його поглядом.",
        correct: "would see",
        options: ["will see", "saw", "would see", "sees"]
    },
    {
        title: "Револьвер на стіні",
        prompt: "A revolver and silver bullets ___ on the wall.",
        story: "На стіні висіли старий револьвер і срібні кулі.\nДжоні здивовано завмер, а Арчі вперше за вечір виглядав трохи задоволеним.",
        correct: "were hanging",
        options: ["were hanging", "was hanging", "hanged", "hangs"]
    },
    {
        title: "Виття за дверима",
        prompt: "If they didn't leave now, the werewolves ___ them.",
        story: "З лісу почулося довге виття, а навколо будинку замиготіли великі тіні.\nЩось уже наближалося до вхідних дверей.",
        correct: "would find",
        options: ["will find", "found", "find", "would find"]
    },
    {
        title: "Задні двері не допомогли",
        prompt: "The back door ___ locked from the outside.",
        story: "Джоні схопив револьвер і побіг до заднього виходу.\nДвері не відчинилися - хтось замкнув їх із зовнішнього боку.",
        correct: "was",
        options: ["were", "was", "is", "be"]
    },
    {
        title: "Арчі знаходить люк",
        prompt: "Archie found a trapdoor that ___ under the rug.",
        story: "Поки Джоні безуспішно смикав двері, Арчі почав дряпати старий килим.\nПід ним виявився дерев'яний люк.",
        correct: "was hidden",
        options: ["hidden", "hid", "was hidden", "is hiding"]
    },
    {
        title: "Підвал мисливця",
        prompt: "There were old maps ___ the walls.",
        story: "Люк вів до підвалу мисливця.\nНа стінах висіли старі карти Блеквуда з позначками й схемами підземних тунелів.\nОдин із тунелів починався саме тут — у підвалі.",
        correct: "on",
        options: ["on", "in", "at", "to"]
    },
    {
        title: "Останній шанс",
        prompt: "They had to leave before the werewolves ___ inside.",
        story: "Одна з карт показувала тунель до старої дороги.\nЗверху вже тріщали дошки - перевертні намагалися пробратися до будинку.",
        correct: "got",
        options: ["get", "will get", "getting", "got"]
    },
    {
        title: "Світанок",
        prompt: "When the sun rose, the forest finally ___ silent.",
        story: "Джоні та Арчі вибралися з тунелю, коли над деревами з'явилося сонце.\nВиття припинилося, а темні постаті розчинилися в лісі.",
        correct: "became",
        options: ["become", "became", "becomes", "was become"]
    }
];
const questions = scenes.map((scene, sceneIndex) => {
    const number = sceneIndex + 1;
    const imageName = `scene-${String(number).padStart(2, "0")}${number >= 11 && number <= 14 ? "-composition" : ""}.jpg`;
    const next = number === scenes.length ? "__end__" : `scene_${String(number + 1).padStart(2, "0")}`;
    return {
        id: `scene_${String(number).padStart(2, "0")}`,
        type: "single-choice",
        title: scene.prompt,
        subtitle: scene.story,
        visual: {
            type: "image",
            src: `${assetBase}/${imageName}`,
            mobileSrc: `${assetBase}/${imageName}`,
            width: 1536,
            height: 2532,
            alt: `${scene.title}: Джоні та Арчі у Блеквуді`,
            crop: "cover",
            motion: "none"
        },
        answers: scene.options.map((label, answerIndex) => {
            const correct = label === scene.correct;
            return {
                id: correct ? "correct" : `option_${answerIndex + 1}`,
                label,
                next,
                scores: { grammar: correct ? 1 : 0 },
                tags: correct ? ["correct"] : []
            };
        })
    };
});
export const halloweenQuiz = {
    id: "englishdom-halloween-quest",
    slug: "halloween",
    version: 2,
    presentation: {
        style: "comic-quest",
        counter: { enabled: true, totalSteps: 20 },
        questionTransition: "instant",
        skipAnalysis: false,
        ambientAudio: {
            src: `${assetBase}/blackwood-ambient.mp3`,
            volume: 0.16,
            loop: true
        },
        comicQuest: {
            logoSrc: "/assets/quizzes/englishdom/logo-white.png",
            totalScenes: 20,
            sceneFrames: {
                scene_01: { offsetY: -7.5 },
                scene_06: { offsetY: 2, height: 88, paperTop: "max(calc(var(--scene-canvas-height) * .55), 102cqw)" },
                scene_07: { offsetY: 2, height: 88, paperTop: "max(calc(var(--scene-canvas-height) * .55), 102cqw)" },
                scene_10: { offsetY: 3, height: 92, paperTop: "max(calc(var(--scene-canvas-height) * .52), 98cqw)" },
                scene_11: { offsetY: 3 },
                scene_12: { offsetY: 3 },
                scene_13: { offsetY: 3 },
                scene_14: { offsetY: 3 },
                scene_16: { offsetY: 3, height: 90, paperTop: "max(calc(var(--scene-canvas-height) * .52), 98cqw)" },
                scene_17: { offsetY: 4 },
                scene_20: { offsetY: -10 }
            },
            parchmentSrc: `${assetBase}/parchment.png`,
            analysisBackdrop: {
                type: "image",
                src: `${assetBase}/analysis-blackwood-pumpkin.jpg`,
                width: 941,
                height: 1672,
                alt: "Блеквуд на світанку",
                crop: "cover",
                objectPosition: "center",
                mobileObjectPosition: "center",
                motion: "none"
            },
            lockedResultArt: {
                type: "image",
                src: `${assetBase}/result-locked-art.jpg`,
                width: 1161,
                height: 1355,
                alt: "Арчі охороняє запечатаний розбір на столі мисливця",
                crop: "cover",
                objectPosition: "center",
                mobileObjectPosition: "center",
                motion: "reveal"
            },
            leadArt: {
                type: "image",
                src: `${assetBase}/lead-mailbox-art.jpg`,
                width: 1448,
                height: 1086,
                alt: "Арчі сидить на старій поштовій скриньці з листом",
                crop: "cover",
                objectPosition: "center",
                mobileObjectPosition: "center",
                motion: "reveal"
            },
            unlockedResultArt: {
                type: "image",
                src: `${assetBase}/result-unlocked-art.jpg`,
                width: 1672,
                height: 941,
                alt: "Джоні та Арчі виходять із Блеквуда на світанку",
                crop: "cover",
                objectPosition: "center",
                mobileObjectPosition: "center",
                motion: "reveal"
            },
            finalStoryBeat: "Револьвер Джоні так і не знадобився - і це на краще, бо стріляти він усе одно не вмів. А от англійська тобі точно знадобиться."
        },
        completion: {
            mode: "telegram",
            lockedTitle: "Твій результат готовий",
            lockedText: "Залиш контакти, щоб отримати результати, розбір помилок та персональний план.",
            successTitle: "Твій персональний план готовий",
            successText: "Ми зберегли твої відповіді. Забирай розбір помилок і персональний план навчання.",
            ctaLabel: "Отримати персональний план",
            ctaUrl: "https://t.me/englishdom_ua_bot/?start=qz=quiz__tfm=pp3"
        }
    },
    metadata: {
        name: "Englishdom",
        language: "uk",
        description: "Halloween comic grammar quest with Johnny and Archie.",
        pageTitle: "Таємничий ліс | Englishdom"
    },
    startQuestionId: "scene_01",
    start: {
        enabled: true,
        renderer: "native",
        mode: "cta",
        layout: "full-bleed",
        title: "Halloween English Quiz",
        subtitle: "20 сцен. Одна історія. Твій рівень англійської.",
        cta: { label: "Почати квест", action: "startQuiz" },
        media: {
            type: "image",
            src: `${assetBase}/cover-quest.jpg`,
            mobileSrc: `${assetBase}/cover-quest.jpg`,
            alt: "Джоні та кіт Арчі йдуть крізь нічний ліс до будинку в Блеквуді"
        },
        background: { type: "color", value: "#071015" },
        logo: { enabled: false }
    },
    landing: { enabled: false, sections: [] },
    progress: { mode: "linear", capFinalQuestionAt99: true },
    phone: {
        defaultCountry: "UA",
        preferredCountries: ["UA", "PL", "CZ", "DE"],
        searchable: true
    },
    questions,
    scoring: {
        categories: ["grammar"],
        normalizeTo: 100,
        tieBreaker: ["halloween_result"]
    },
    results: [
        {
            id: "halloween_result",
            category: "grammar",
            title: "Ти вибрався з Блеквуда",
            description: "Історію завершено. Тепер подивимося, як ти пройшов граматичні пастки.",
            preview: "Твій результат і помилки вже пораховані.",
            gatedContent: "Отримай детальний розбір і персональний план навчання."
        }
    ],
    analysis: {
        title: "Перевіряємо, як ти пройшов Блеквуд",
        subtitle: "Зіставляємо 20 відповідей і готуємо розбір граматичних пасток.",
        display: "stage-cards",
        durationMs: 3000,
        reducedMotionDurationMs: 300,
        steps: [
            { id: "answers", title: "Перевіряємо 20 відповідей" },
            { id: "mistakes", title: "Знаходимо сильні місця та помилки" },
            { id: "plan", title: "Готуємо персональний план" }
        ],
        checkpoints: [0, 18, 35, 52, 72, 88, 100]
    },
    leadForm: {
        title: "Відкрий свій розбір",
        subtitle: "Залиш контакти, щоб відкрити результат, розбір помилок та персональний план.",
        placement: "next-step",
        fields: {
            name: { enabled: true, required: true, label: "Ім'я" },
            phone: { enabled: true, required: true, label: "Телефон" },
            email: { enabled: true, required: true, label: "Електронна пошта" }
        },
        privacyConsentRequired: true,
        marketingConsentEnabled: true,
        submitLabel: "Отримати результати та план"
    },
    integrations: {
        googleSheets: {
            enabled: true,
            leadsTab: "halloween_leads",
            rawTab: "halloween_raw",
            questionHeaderMode: "question_ids"
        }
    },
    uiCopy: {
        back: "Назад",
        progressLabel: "Прогрес",
        resultEyebrow: "Результат квесту",
        resultCta: "Відкрити результат",
        privacyConsent: "Погоджуюся з політикою конфіденційності",
        marketingConsent: "Хочу отримувати корисні поради про навчання",
        leadSaved: "Контакти збережено"
    },
    theme: halloweenTheme
};
